import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';;
import { AuthService } from '../auth/auth.service';
import { Aviso } from '../../models/Aviso';
import { AvisoDetalhado } from '../../models/AvisoDetalhado';
import { AvisoView } from '../../models/AvisoView';
import { environment } from '../../../environments/environment';
import axiosClient from '../../../shared/axios/axios-client';

@Injectable({
  providedIn: 'root',
})
export class AvisoService {
  private apiUrl = `${environment.apiUrl}/aviso`;

  constructor(private http: HttpClient, private authService: AuthService) { }

  getAvisosDoCriador(): Observable<Aviso[]> {
    const token = this.authService.getToken();
    const headers = token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : undefined;

    const url = this.apiUrl;

    return this.http.get<Aviso[]>(url, { headers });
  }

  getMeusAvisos(): Observable<{ avisos: AvisoView[] }> {
    const token = this.authService.getToken();
    const headers = token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : undefined;

    const url = `${this.apiUrl}/meus`;

    return this.http.get<{ avisos: AvisoView[] }>(url, { headers });
  }

  visualizarAviso(idAviso: number) {
    const token = this.authService.getToken();
    const headers = token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : undefined;

    const url = `${this.apiUrl}/visualizado`;
    return this.http.put(url, [idAviso], { headers });
  }

  getAvisoDetalhesById(id: number): Observable<AvisoDetalhado> {
    const token = this.authService.getToken();
    const headers = token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : undefined;

    const url = `${this.apiUrl}/${id}`;

    return this.http.get<AvisoDetalhado>(url, { headers });
  }

  removerAvisos(avisos: number[]): Observable<void> {
    const token = this.authService.getToken();
    const headers = token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : undefined;

    const url = `${this.apiUrl}/excluir`;

    return this.http.put<void>(url, { avisos }, { headers });
  }

  criarOuAtualizarAviso(aviso: any) {
    return from(axiosClient.post(this.apiUrl, aviso).then(res => res.data));
  }

  getUnreadAvisosCount(): Observable<{ count: number }> {
    return new Observable(observer => {
      this.getMeusAvisos().subscribe({
        next: (response) => {
          const unreadCount = response.avisos.filter(aviso => {
            const isUnread = aviso.status?.toLowerCase() !== 'visualizado';
            return isUnread;
          }).length;
          observer.next({ count: unreadCount });
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        }
      });
    });
  }

  editarAviso(aviso: Aviso, id: number) {
    const url = `${this.apiUrl}/${id}`
    return from(axiosClient.put(url, aviso).then(res => res.data));
  }
}
